import {useEffect, useState} from 'react';
import {apis} from '../services/alm';

const useCalendar = (userId?: string) => {
  const [data, setData] = useState<{ meetData: any[] }>({ meetData: [] });

  useEffect(() => {
    if (userId) {
      getAllEnrolled();
    }
  }, [userId]);

  const getAllEnrolled = async () => {
    try {
      const finalResult: any[] = [];
      const response: any = await apis.getCalender(userId);
      finalResult.push(...response.data);
      let isTrue = response?.links?.next;
      let meetData = response.data.filter((element: any) => element.attributes.enrolled);

      while (isTrue) {
        const res: any = await apis.nextBaseUrl(isTrue);
        finalResult.push(...res.data);
        meetData = [...meetData, ...res.data.filter((element: any) => element.attributes.enrolled)
          ];
        isTrue = res?.links?.next || false;
      }
      if (meetData.length > 0) {
        setData({ meetData });
      }
    } catch (e) {
      console.error(e);
    }
  };
  return {...data};
};

export default useCalendar;
